module.exports = __webpack_public_path__ + "static/media/TW-GerardRoss-mobile-411x93@2x-80.9bbadd25.jpg";